export const hubspotDivId = 'hubspotContainer';
export const region = 'na1';
export const portalId = '6866744';
